import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import ErrorTemplate from '../../templates/errortemplate/ErrorTemplate';
import OptinConfirmationPage from '../../templates/optinconfirmationtemplate/OptinConfirmationTemplate';
import email from '../email';

var ES6Promise = require('es6-promise');
ES6Promise.polyfill();
var axios = require('axios');

class OptinConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: null,
      detail: null
    };
  }

  componentDidMount() {
    this.callConfirmation();
  }

  callConfirmation() {
    const urlParams = new URLSearchParams(this.props.location.search);
    var key = urlParams.get('info');
    key = key !== null ? key : '';
    axios.get(process.env.REACT_APP_BACKEND_URL + 'api/v1/ci', {
      params: {
        info: key
      }
    })
      .then((response) => {
        this.setState({
          page: response.data.landing,
          detail: response.data.responseParameter
        });
      })
      .catch(err => {
        this.setState({
          page: 'ticketPage',
          detail: err.response.data.responseParameter
        });
      });
  }

  render() {
    if (!this.state.page) {
      return <div />;
    }
    if (this.state.page === 'ticketPage') {
      return (
        <>
          <Helmet><title>{email.optin.ui.html.head.title.error.eng}</title></Helmet>
          <ErrorTemplate detail={this.state.detail} />
        </>
      );
    }

    return (
      <>
        <Helmet><title>{email.optin.ui.html.head.title.optin.confirmation.eng}</title></Helmet>
        <OptinConfirmationPage detail={this.state.detail} />
      </>
    );
  };
}

export default OptinConfirmation;
